import Spinner from './Spinner'

export * from './Spinner'
export default Spinner
